import React, { useState } from "react";
import { Play } from "lucide-react";

type YouTubeFacadeProps = {
  videoId: string;
  title: string;
  className?: string;
};

/** Capa + play; o player do YouTube só carrega no clique (não pesa no topo da página). */
const YouTubeFacade: React.FC<YouTubeFacadeProps> = ({ videoId, title, className = "" }) => {
  const [playing, setPlaying] = useState(false);

  return (
    <div className={`mkt-video ${className}`}>
      {playing ? (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1&autoplay=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          className="group absolute inset-0 h-full w-full cursor-pointer"
          aria-label={`Assistir: ${title}`}
        >
          <img
            src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
            loading="eager"
          />
          <span className="absolute inset-0 bg-black/15 transition group-hover:bg-black/25" aria-hidden />
          <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#2B5A41]/90 shadow-xl transition group-hover:scale-105 sm:h-20 sm:w-20">
            <Play className="ml-1 h-7 w-7 fill-white text-white sm:h-9 sm:w-9" aria-hidden />
          </span>
        </button>
      )}
    </div>
  );
};

export default YouTubeFacade;
